import React from 'react';
import './Spinner.css';
import { ProgressSpinner } from 'primereact/progressspinner';

const LoadingSpinner = ({ size = 'normal' }) => {
  return (
    <div className='loading-spinner-container'>
      <ProgressSpinner className={`loading-spinner loading-spinner-${size}`} />
    </div>
  );
};

export default LoadingSpinner;
